// JsFromRoutes CacheKey 55788084e90e861cfbb981678ae86547
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/testing_tools/contacts/add_back_prompt/send_test_email'),
}
